/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-is-mounted */
import React from 'react';
import styled, { withTheme } from 'styled-components';
import Content from './layout/content/Content';

const Wrapper = styled.div`
  min-height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const StackTraceWrapper = styled.pre`
  background: #f6f8fa;
  padding: 0 20px 20px 0;
`;

const HorizontalRow = styled.hr`
  border-top: 1px solid;
  width: 100%;
`;

const Button = styled.button`
  display: inline;
  background: transparent;
  border: 0;
  padding: 0;
  margin-left: 8px;
  color: #0000ff;
  &:active {
    outline: 0;
  }
  &:focus {
    outline: 0;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, reason: '', stackTrace: '' };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error('ERROR BOUNDARY::: Error Caught in getDerivedStateFromError -', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.error('ERROR BOUNDARY::: Error Caught in ComponentDidCatch -', error, errorInfo);
    this.setState({ reason: error?.toString(), stackTrace: errorInfo?.componentStack });
  }

  render() {
    const { hasError, reason, stackTrace } = this.state;
    const { theme, children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <Content theme={ theme } layout='errorBoundary'>
          <Wrapper>
            <div>
              <h1>Something went wrong!</h1>
              <h4 className='text-center'>
                <span>Click</span>
                <Button type='button' onClick={ () => window.location.reload() }>
                  here
                </Button>{' '}
                <span>to reload</span>
              </h4>
            </div>
            {(reason || stackTrace) && (
              <div>
                <HorizontalRow />
                {reason && <h4 className='text-center'>{reason}</h4>}
                {stackTrace && <StackTraceWrapper>{stackTrace}</StackTraceWrapper>}
              </div>
            )}
          </Wrapper>
        </Content>
      );
    }

    return children;
  }
}

export default withTheme(ErrorBoundary);
